<template>
    <div class="employer-hr-config">
        <div class="c-common-space c-responsive-fixwidth">
            <div class="c-common-box-shadow c-employer-box-content clearfix o-skillset-area">
                <div class="col-sm-12">
                    <div class="c-common-space c-responsive-fixwidth">
                        <div class="clearfix o-employer-a">
                            <h3>HR Policy Configuration</h3>

                            <div class="row" style="margin-bottom: 15px;">
                                <div class="col-sm-6">
                                    <label class="common-label-text">Enable Policy Acceptance</label>
                                    <div class="toggle-btn">
                                        <el-switch
                                            style="display: block"
                                            v-model="config.enabled"
                                            active-color="#13ce66"
                                            inactive-color="#dcdfe6">
                                        </el-switch>
                                    </div>
                                </div>
                            </div>

                            <div v-if="config.enabled">
                                <div class="row" style="margin-bottom: 15px;">
                                    <div class="col-sm-12">
                                        <label class="common-label-text">Preset Policy Items</label>
                                        <div class="checkbox-group" style="margin-top: 5px;">
                                            <div v-for="item in presetItems" :key="item.key" class="checkbox" style="margin-bottom: 8px;">
                                                <label>
                                                    <input type="checkbox" v-model="config.preset_items" :value="item.key">
                                                    <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                    {{ item.label }}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-bottom: 15px;">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <label class="common-label-text">Custom Policy Text</label>
                                            <textarea
                                                class="form-control"
                                                rows="5"
                                                placeholder="Enter any additional policy text here..."
                                                v-model="config.custom_policy_text"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" style="margin-bottom: 15px;">
                                    <div class="col-sm-6">
                                        <label class="common-label-text">Require re-acceptance when policy changes</label>
                                        <div class="toggle-btn">
                                            <el-switch
                                                style="display: block"
                                                v-model="config.require_reaccept"
                                                active-color="#13ce66"
                                                inactive-color="#dcdfe6">
                                            </el-switch>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 text-right">
                                        <a href="javascript: void(0)" @click="saveConfig()" class="c-common-btn c-common-btn--large c-common-btn--green">
                                            <i class="fa fa-save"></i> Save
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import service from '../../services.js';

    export default {
        props: {
            employerId: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                config: {
                    enabled: false,
                    preset_items: [],
                    custom_policy_text: '',
                    require_reaccept: false,
                },
                presetItems: [
                    { key: 'safety_orientation', label: 'Safety orientation required before first day' },
                    { key: 'workers_comp', label: 'Workers\' compensation information will be provided' },
                    { key: 'union_dues', label: 'Union dues and assessment schedule' },
                    { key: 'harassment', label: 'Harassment & discrimination policy acknowledgment' },
                    { key: 'drug_alcohol', label: 'Drug & alcohol policy acknowledgment' },
                    { key: 'confidentiality', label: 'Confidentiality / NDA agreement' },
                    { key: 'emergency_contact', label: 'Emergency contact information required' },
                    { key: 'ppe', label: 'Personal protective equipment (PPE) requirements' },
                ],
            };
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
            }),
        },
        methods: {
            loadConfig() {
                this.$Progress.start();
                service.get('employer/' + this.employerId + '/hr-config', {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$Progress.finish();
                    if (res.data && res.data.result) {
                        let result = res.data.result;
                        this.config.enabled = !!result.enabled;
                        this.config.preset_items = result.preset_items || [];
                        this.config.custom_policy_text = result.custom_policy_text || '';
                        this.config.require_reaccept = !!result.require_reaccept;
                    }
                }).catch((err) => {
                    this.$Progress.finish();
                    console.log('HR config load error:', err);
                });
            },
            saveConfig() {
                this.$Progress.start();
                service.put('employer/' + this.employerId + '/hr-config', this.config, {
                    'Authorization': this.userToken,
                }).then((res) => {
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Success',
                        message: 'HR policy configuration saved.',
                        type: 'success',
                    });
                }).catch((err) => {
                    this.$Progress.finish();
                    this.$notify({
                        title: 'Error',
                        message: 'Failed to save HR policy configuration.',
                        type: 'error',
                    });
                    console.log('HR config save error:', err);
                });
            },
        },
        created() {
            this.loadConfig();
        },
    };
</script>
